import React, {memo} from 'react'
import PropTypes from 'prop-types'
import Typist from 'react-typist'
import withStyles from '@material-ui/core/styles/withStyles'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'

import './Banner.scss'

const typistCursor = {
  show: false,
}

const StyledGrid = withStyles({
  root: {
    height: '100%',
  },
})(Grid)

Banner.propTypes = {
  width: PropTypes.string.isRequired,
  isLoaded: PropTypes.bool.isRequired,
}

function Banner({isLoaded, width}) {
  return (
    <section className="Banner">
      <div className="Banner-Background" />
      <div className="Banner-Container Container">
        <StyledGrid container spacing={2}>
          <Hidden mdDown>
            <Grid item xs={1} />
          </Hidden>
          <StyledGrid item xs={12} lg={10}>
            <div className="Banner-Content">
              {isLoaded && (
                <div>
                  {width === 'sm' ? (
                    <Typist key={1} className="Banner-Typist" cursor={typistCursor}>
                      <h1 className="Banner-Title">
                        Perfectly
                        <br />
                        crafted
                        <br />
                        websites for
                        <br />
                        everyone
                      </h1>
                    </Typist>
                  ) : width === 'xs' ? (
                    <Typist key={2} className="Banner-Typist" cursor={typistCursor}>
                      <h1 className="Banner-Title">
                        Perfectly
                        <br />
                        crafted
                        <br />
                        websites
                        <br />
                        for
                        <br />
                        everyone
                      </h1>
                    </Typist>
                  ) : (
                    <Typist key={3} className="Banner-Typist" cursor={typistCursor}>
                      <h1 className="Banner-Title">
                        Perfectly crafted
                        <br />
                        websites for
                        <br />
                        everyone
                      </h1>
                    </Typist>
                  )}
                  <Hidden xsDown>
                    <p className="Banner-Text">
                      Simple, intuitive, and elegant. Our websites are specifically created with premier tools and
                      technology tailored to your business needs. Easy to maintain with technical support always
                      available.
                    </p>
                  </Hidden>
                </div>
              )}
            </div>
          </StyledGrid>
          <Hidden mdDown>
            <Grid item xs={1} />
          </Hidden>
        </StyledGrid>
      </div>
    </section>
  )
}

export default memo(Banner)
